import React, { Component } from "react";
import { Translate } from "react-redux-i18n";
import "../../styles/components/legalCeme/LegalCeme.scss";
import evio from "../../styles/images/evio.svg";

let counter;

class GeneralConditions extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    counter = 1;
  }

  // uses a global counter to render General Conditions list items & Annex Lidt items
  renderListItems(totalPoints, simpleGC) {
    let list = [];
    let childrenSimpleGC = [0, 0, 6, 2, 9, 5, 5, 6, 6, 8, 2, 3, 8, 2, 1];
    let childrenGCAnnex = [1, 10, 10, 5, 4, 15, 4, 4, 2, 4];

    if (simpleGC === true) {
      while (counter <= totalPoints) {
        list.push(
          <li key={counter}>
            {counter === 1 ? (
              <span>
                <span className="title">
                  <Translate value="legalCeme_GC_title1" />
                </span>
                <Translate value="legalCeme_GC_text1" />
                <a href=" https://evio.pt/" target="_blank "> https://evio.pt/</a>
                <Translate value="legalCeme_GC_text2" />
                <span> </span>
                <a href="https://evio.pt/" target="_blank ">https://evio.pt/</a>
                <Translate value="legalCeme_GC_text3" />
              </span>
            ) : counter === 2 ? (
              <span>
                <span className="title">
                  <Translate value="legalCeme_GC_title2" />
                </span>
                <span>
                  <Translate value="legalCeme_GC_point2_text1" />
                </span>
              </span>
            ) : (
              <span className="title">
                <Translate value={`legalCeme_GC_title${counter}`} />
              </span>
            )}
            {
              <ol>
                {this.renderListItemChildren(
                  childrenSimpleGC[counter - 1],
                  true
                )}
              </ol>
            }
          </li>
        );
        counter++;
      }
    } else {
      counter = 1;
      while (counter <= totalPoints) {
        list.push(
          <li key={counter}>
            {
              <span className="title">
                <Translate value={`legalCeme_GCAnexo_title${counter}`} />
              </span>
            }
            {
              <ol>
                {this.renderListItemChildren(
                  childrenGCAnnex[counter - 1],
                  false
                )}
              </ol>
            }
          </li>
        );
        counter++;
      }
    }
    return list;
  }

  // renders children for each list item
  renderListItemChildren(Number, simpleGC) {
    let childrenListItems = [];
      
    if (simpleGC === true) {
      for (let i = 1; i <= Number; i++) {
        childrenListItems.push(
          <li key={i}>
            <Translate value={`legalCeme_GC_point${counter}_child${i}`} />
                {counter === 10 && i === 8 ? (
              <span>
                <span>
                  <Translate value="legalCeme_GC_point10_child8" />
                  <span> </span>
                <a href="mailto:geral@cnpd.pt/">geral@cnpd.pt</a>
                <br />
                </span>
                <br />
              </span>
            ): counter === 13 && i === 7 ? (
              <span>
                <span>
                  <Translate value="legalCeme_GC_point13_child7" />
                  <span> </span>
                  <a href="mailto:support@go-evio.com">support@go-evio.com</a>
                  <span> .</span>
                  <br />
                </span>
                <br />
              </span>
              ): counter === 14 && i === 2 ? (
                <span>
                  <Translate value="legalCeme_GC_point14_child2_text1" />
                  <span> </span>
                <a href="https://www.consumidor.gov.pt/ral-mapa-e-lista-de-entidades.aspx" target="_blank ">https://www.consumidor.gov.pt/ral-mapa-e-lista-de-entidades.aspx</a>
                  <span> </span>
                  <Translate value="legalCeme_GC_point14_child2_text2" />
                  <span> </span>
                <a href="https://www.ciab.pt" target="_blank ">www.ciab.pt</a>
                  <Translate value="legalCeme_GC_point14_child2_text3" />
                <a href="https://arbitragem.autonoma.pt." target="_blank " >https://arbitragem.autonoma.pt.</a>
                <Translate value="legalCeme_GC_point14_child2_text4" />
                </span>
                ) : (true)
                }
              <ol>
                  {counter === 9 && i === 2 ? (
                      this.renderListItemGranChildren(1, 2, 9)
                  ) : counter === 9 && i === 3 ? (
                    this.renderListItemGranChildren(7, 3, 9)
                  ) : counter === 10 && i === 6 ? (
                    this.renderListItemGranChildren(7, 6, 10)
                  ) : (
                    false
                  )
                  }
              </ol>
          </li>
        )
      }
    } else {
      for (let i = 1; i <= Number; i++) {
        childrenListItems.push(
          <li key={i}>
            <Translate value={`legalCeme_GCAnexo_point${counter}_child${i}`} />
          </li>
        );
      }
    }
    return childrenListItems;
  }

  // renders Grand children for each list item that has some
  renderListItemGranChildren(GranChilds, indice, counter) {
    let granChildrenListItems = [];
      for (let j = 1; j <= GranChilds; j++) {
        granChildrenListItems.push(
          <li key={j}>
            <Translate value={`legalCeme_GC_point${counter}_child${indice}_dot${j}`} />
          </li>          
        )
      }
      return granChildrenListItems;
  }

  render() {
    return (
      <div id="gc">
        <div className="evio-logo">
          <img src={evio} alt="" />
        </div>
        <h4 className="gc-title">
          <Translate value="legalCeme_GC_mainTitle1" />
          <br />
          <Translate value="legalCeme_GC_mainTitle2" />
          <br />
        </h4>
        <br />
        <div className="gc-text">
          {<ol start={counter}>{this.renderListItems(15, true)}</ol>}
        </div>
        <br />
        <h4 className="gc-title">
          <Translate value="legalCeme_GCAnexo_mainTitle1" />
          <br />
          <Translate value="legalCeme_GCAnexo_mainTitle2" />
        </h4>
        <div className="gc-text">
          {<ol start={counter}>{this.renderListItems(10, false)}</ol>}
        </div>
      </div>
    );
  }
}

export default GeneralConditions;
